import { render, staticRenderFns } from "./SingleBell.vue?vue&type=template&id=4885b852&scoped=true&"
import script from "./SingleBell.vue?vue&type=script&lang=js&"
export * from "./SingleBell.vue?vue&type=script&lang=js&"
import style0 from "./SingleBell.vue?vue&type=style&index=0&id=4885b852&lang=scss&scoped=true&"
import style1 from "./SingleBell.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4885b852",
  null
  
)

export default component.exports